import { cn } from '@/lib/utils'

interface FilterOption { value: string; label: string }
interface FilterDef { key: string; label: string; options: FilterOption[] }

interface FilterBarProps {
  filters: FilterDef[]
  activeFilters: Record<string, string>
  onFilterChange: (key: string, value: string) => void
  className?: string
}

export function FilterBar({ filters, activeFilters, onFilterChange, className }: FilterBarProps) {
  return (
    <div className={cn('flex flex-wrap items-center gap-3 rounded-xl border border-border bg-card p-3 shadow-sm', className)}>
      {filters.map((filter) => (
        <div key={filter.key} className="flex items-center gap-1.5">
          <label className="text-xs font-medium text-muted-foreground">{filter.label}</label>
          <select value={activeFilters[filter.key] ?? ''} onChange={(e) => onFilterChange(filter.key, e.target.value)}
            className="h-10 rounded-lg border border-border bg-background px-2 text-xs text-foreground outline-none transition-colors focus:border-primary focus:ring-2 focus:ring-primary/20">
            {filter.options.map((opt) => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
          </select>
        </div>
      ))}
    </div>
  )
}
